// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as BackgroundScrollFade$PrezzeeRibbon from "../../../abstracts/BackgroundScrollFade.bs.js";

function Component(T) {
  var staticBackground = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(T.backgroundColor)]);
  var dynamicBackground = function (alpha) {
    var c = Theme__Color$PrezzeeRibbon.colourToRgba(T.backgroundColor, alpha);
    return BsCssJs$PrezzeeRibbon.style([
                BsCssJs$PrezzeeRibbon.backgroundColor(c),
                BsCssJs$PrezzeeRibbon.transition(200, 0, "easeInOut", "background-color")
              ]);
  };
  var Styles = {
    staticBackground: staticBackground,
    dynamicBackground: dynamicBackground
  };
  var TopNavigationBar__Background$Component$FadeBackground = function (props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    var background = BackgroundScrollFade$PrezzeeRibbon.useBackgroundScrollFade(dynamicBackground, 20, props.fade);
    return JsxRuntime.jsx("div", {
                children: props.children,
                className: Classnames([
                      background,
                      className$1
                    ])
              });
  };
  var FadeBackground = {
    make: TopNavigationBar__Background$Component$FadeBackground
  };
  var TopNavigationBar__Background$Component$StaticBackground = function (props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return JsxRuntime.jsx("div", {
                children: props.children,
                className: Classnames([
                      staticBackground,
                      className$1
                    ])
              });
  };
  var StaticBackground = {
    make: TopNavigationBar__Background$Component$StaticBackground
  };
  return {
          Styles: Styles,
          FadeBackground: FadeBackground,
          StaticBackground: StaticBackground
        };
}

export {
  Component ,
}
/* classnames Not a pure module */
